import { useState, useEffect } from 'react'
import { FaDiscord } from 'react-icons/fa'
import { SecondaryButton, TransparentButton } from 'common/button'
import { Typography } from 'components/common/typography'
import { MdClose } from 'react-icons/md'
import ConfirmationModal from 'common/confirmation-modal'
import { useUnlinkDiscord } from 'mutations/profile'
import Notification from './notification'
import SocialMediaVinculationStyled from './social-media-vinculation'

const DISCORD_CLIENT_ID = process.env.DISCORD_CLIENT_ID || 'discord-client-id'


function DiscordButton({ username }) {
  const [remove, setRemove] = useState(false)
  const [callbackUrl, setCallbackUrl] = useState()
  const { mutate, isError, isSuccess } = useUnlinkDiscord()

  useEffect(() => {
    if (window?.location) {
      setCallbackUrl(encodeURIComponent(`${window.location.origin}/api/discord/callback`))
    }
  }, [])

  const params = `?client_id=${DISCORD_CLIENT_ID}&redirect_uri=${callbackUrl}&response_type=code&scope=guilds.join%20identify`
  const url = `https://discord.com/api/oauth2/authorize${params}`

  if (username) {
    return (
      <>
        <div className="vinculated-container">
          <a
            href={`https://discordapp.com/users/${username}`}
            target="_blank"
            rel="noopener noreferrer"
            className="vinculated"
          >
            <div className="icon-vinculated discord">
              <FaDiscord size="30px" color="white" />
            </div>
          </a>
          <TransparentButton onClick={() => setRemove(true)}>
            <MdClose />
          </TransparentButton>
        </div>
        <ConfirmationModal
          title="¿Deseas desvincular tu cuenta de Discord?"
          description="Esta cuenta ya no estará asociada a tu perfil ni a tus proyectos."
          onConfirm={() => mutate()}
          onCancel={() => setRemove(false)}
          cta="Desvincular"
          visible={remove}
        />
        {isError ? (
          <Notification
            title="Desvinculacion fallida"
            message="Ha ocurrido un problema al intentar eliminar tu cuenta de github."
            report
            error
          />
        ) : null}
      </>
    )
  }

  return (
    <SocialMediaVinculationStyled className="social-media-vinculation" color="#3B1375">
      <div className="icon-container">
        <FaDiscord size="48px" color="white" />
      </div>
      <div className="vinculation-copy">
        <Typography font="headline6" as="h3">
          Vincula tu cuenta de Discord
        </Typography>
        <Typography font="regular">
          Al vincular tu cuenta de Discord podrás obtener feedback sobre los proyectos que te encuentres trabajando para mejorar cualquier detalle.
        </Typography>
      </div>
      <a href={url} target="_self" rel="noopener noreferrer">
        <SecondaryButton height="48" fitContent fullWidth fontWeight="500">
          Vincular Discord
        </SecondaryButton>
      </a>
      {isSuccess ? (
        <Notification
          title="Desvinculacion exitosa"
          message="Hemos eliminado tu cuenta de discord, recuerda que es necesaria una para poder mandar a revisión tus proyectos"
        />
      ) : null}
    </SocialMediaVinculationStyled>
  )
}

export default DiscordButton
